import { dialogs, i18next, view } from '@yola/ws-sdk';
import store from 'src/js/store';
import constants from 'src/js/modules/read-only-mode/constants';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import takeControl from 'src/js/modules/read-only-mode/operations/take-control';

const showReadOnlyModeDialog = ({ reloadOnCancel = false } = {}) => {
  dialogs.operations.show(dialogTypes.READ_ONLY_ALERT_DIALOG, {
    imgSrc: './images/take-control.svg',
    width: 334,
    height: 'auto',
    captions: {
      title: i18next.t('Take editing control?'),
      description: i18next.t(
        'You are currently in read-only mode because another editing session is active in a different tab. Would you like to take control here?'
      ),
      submit: i18next.t('Take control'),
      dismiss: i18next.t('Cancel'),
    },
    onSubmit: () => {
      takeControl();
      dialogs.operations.hide({ [constants.READONLY_SYMBOL]: true });
    },
    onDismiss: () => {
      if (reloadOnCancel) {
        store.dispatch(view.actions.forceReloadView());
      }
      dialogs.operations.hide({ [constants.READONLY_SYMBOL]: true });
    },
  });
};

export default showReadOnlyModeDialog;
